import React from 'react';
import { usageSteps } from '../data/mock';
import { ChevronRight } from 'lucide-react';

const UsageSection = () => {
  return (
    <section id="usage" className="py-20 lg:py-28 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
            4ステップで診断完了
          </h2>
          <p className="text-slate-400 text-lg">
            面倒な設定は不要。URLまたはPDFを共有するだけで始められます
          </p>
        </div>

        {/* Steps Flow */}
        <div className="flex flex-col lg:flex-row items-center justify-center gap-4 lg:gap-2">
          {usageSteps.map((step, index) => {
            const isLast = index === usageSteps.length - 1;
            return (
              <React.Fragment key={step.step}>
                {/* Step Card */}
                <div className="w-full lg:w-auto lg:flex-1 max-w-xs">
                  <div className="bg-slate-800/50 border border-slate-700/50 rounded-xl p-6 hover:border-cyan-500/30 transition-all duration-300 hover:-translate-y-1 h-full">
                    {/* Step number */}
                    <div className="w-10 h-10 bg-cyan-500 rounded-full flex items-center justify-center mb-4">
                      <span className="text-slate-900 font-bold">
                        {step.step}
                      </span>
                    </div>

                    {/* Content */}
                    <h3 className="text-white font-semibold text-lg mb-2">
                      {step.title}
                    </h3>
                    <p className="text-slate-400 text-sm leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>

                {/* Arrow between cards */}
                {!isLast && (
                  <>
                    {/* Desktop arrow */}
                    <div className="hidden lg:flex items-center justify-center px-2">
                      <ChevronRight className="w-8 h-8 text-cyan-500" />
                    </div>
                    {/* Mobile arrow */}
                    <div className="lg:hidden flex justify-center py-2">
                      <svg className="w-6 h-6 text-cyan-500 rotate-90" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </div>
                  </>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default UsageSection;